// @flow

let _callbacks = [];

// We can't guarentee that our `window.addEventListener('DOMContentLoaded')`
// callback will be registered before the event is fired. If we can't catch the
// original onDOMContentLoaded then there's no event, no need for event arguments.
// Try to prevent people from expecting an argument to their callback
type NoArgEventHandler = () => mixed;

function drain() {
  _callbacks.forEach((callback: NoArgEventHandler) => {
    try {
      setImmediate(callback);
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('Error processing onDOMContentLoaded callback', error);
      }
    }
  });
  _callbacks = [];
}

function onDOMContentLoaded(callback: NoArgEventHandler) {
  if (__SERVER__) {
    throw new Error(
      'Invalid call to onDOMContentLoaded. The server has no DOMContentLoaded event.',
    );
  } else if (document) {
    switch (document.readyState) {
      case 'complete':
      case 'loaded':
      case 'interactive':
        callback();
        break;
      default:
        _callbacks.push(callback);
        break;
    }
  }
}

if (!__SERVER__ && window) {
  window.addEventListener('DOMContentLoaded', drain);
}

export default onDOMContentLoaded;
export function __test_only_reset_queue__() {
  _callbacks = [];
}
